import { render, staticRenderFns } from "./mediversion.vue?vue&type=template&id=9d2ddc48"
import script from "./mediversion.vue?vue&type=script&lang=js"
export * from "./mediversion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports